import React, { Component } from 'react';
import { PortalWrapper } from 'components/shared';

import styles from './AnchoredPortal.module.scss';

export class AnchoredPortal extends Component {
  state = {
    anchored: false,
  };

  anchor: HTMLElement | null = null;

  componentDidMount() {
    this.setState({ anchored: true });
  }

  renderContent() {
    const { children } = this.props;
    const { height, left, top, width }: ClientRect = this.anchor!.getBoundingClientRect();

    const style: React.CSSProperties = {
      top,
      left,
      width,
      height,
      zIndex: 1000000,
      position: 'fixed',
    };

    return (
      <PortalWrapper>
        <div style={style}>{children}</div>
      </PortalWrapper>
    );
  }

  render() {
    return (
      <div ref={(ref) => (this.anchor = ref)} className={styles.expando}>
        {this.anchor && this.renderContent()}
      </div>
    );
  }
}

export default AnchoredPortal;
